import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-cpp-business-rule-analysis-dialog',
  templateUrl: './cpp-business-rule-analysis-dialog.component.html',
  styleUrls: ['./cpp-business-rule-analysis-dialog.component.scss']
})
export class CppBusinessRuleAnalysisDialogComponent implements OnInit {
  gridDataList: any;
  webNum: number;
  @Output()
  SearchFilter: EventEmitter<any> = new EventEmitter<any>();

  displayedColumns: string[] = ['product', 'itemNumber', 'orderType', 'itemFlashMessage', 'proprietary', 'packaged', 'xrefCheckBK', 'omniumBP',
    'supplierNumber', 'successfullyProcessed', 'deliveryDate', 'errorMessage'];

  displayedFooterColumns: string[] = this.displayedColumns;
  plAccess = false;
  disclaimerMessage: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private commonService: CommonService,
    private dialogRef: MatDialogRef<CppBusinessRuleAnalysisDialogComponent>) {
    this.webNum = data.gridData.webNum;
    this.gridDataList = data.gridData;
  }

  ngOnInit() {
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.gridDataList.forEach(x => {
      x.display = true;
      x.errorMessage = this.setErrorMessage(x.successfullyProcessed);
    });

    this.plAccess = this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST);
  }
  close() {
    this.dialogRef.close();
  }

  setErrorMessage(successFullyProccesed: string) {
    let errorMessage = '';
    if (successFullyProccesed == 'E') {
      errorMessage = 'Order Errored during Place Order';
    }
    else if (successFullyProccesed == 'F') {
      errorMessage = 'Internal Server Error from Mulesoft';
    }
    else if (successFullyProccesed == 'B') {
      errorMessage = 'Bad Request / Schema validation failed';
    }
    return errorMessage;
  }
}
